import React from 'react'
import {Button,Form,FormGroup,Label,Input} from 'reactstrap';

class ClientForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {error: null, values: props.client || {}}
  }

  static getDerivedStateFromProps(props, state) {
    const values = props.client || {}
    if(values && values.id && !state.values.id) {
      return {...state, values: {...values}}
    }
    return null
  }

  handleChange = (e) => {
    e.preventDefault()
    const values = {...this.state.values, [e.target.name]: e.target.value}
    this.setState({values})
  }

  handleSubmit = () => {
    this.setState({isSubmitting: true})
    this.props.submit(this.state.values).then(() =>
      this.setState({values: {}, isSubmitting: false})
    ).catch(error => this.setState({error: error.message,isSubmitting: false}))
  }

  validate = () =>
    this.state.values.name && this.state.values.name.length>0 &&
    this.state.values.address && this.state.values.address.length>0

  render(){
    const Body = this.props.bodyComponent
    const Buttons = this.props.buttonsComponent
    const valid = this.validate()

    return(
      <Form onSubmit={this.handleSubmit}>
        <Body>
          {this.state.error &&
            <p className="text-danger">{this.state.error}</p>
          }
          {this.state.values.number &&
            <FormGroup>
              <Label for="name">Produktnummer</Label>
              <Input
                readOnly
                type="text"
                className="form-control-plaintext"
                defaultValue={this.state.values.number || ''}/>
            </FormGroup>
          }
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              value={this.state.values.name || ''}
              onChange={this.handleChange}/>
          </FormGroup>

          <FormGroup>
            <Label for="address">Adresse</Label>
            <Input
              type="text"
              name="address"
              id="address"
              value={this.state.values.address || ''}
              onChange={this.handleChange}/>
          </FormGroup>
        </Body>

        <Buttons>
          <Button
            color="primary"
            disabled={!valid || this.state.isSubmitting}
            onClick={this.handleSubmit}>
            {this.state.isSubmitting ? 'Bitte Warten...' : 'Speichern'}
          </Button>{' '}
        </Buttons>
      </Form>
    )
  }
}

ClientForm.defaultProps = {
  bodyComponent: React.Fragment,
  buttonsComponent: React.Fragment
};

export default ClientForm



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ClientForm.js